import { render, staticRenderFns } from "./attributeCategory.vue?vue&type=template&id=70dfc727"
import script from "./attributeCategory.vue?vue&type=script&lang=js"
export * from "./attributeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports